import { useEffect, useRef, useState } from "react";
import { anulaPuesto, getInfoPuesto, obtenerProyectoAdm, obtenerPuestoActivosAdm, obtenerPuestoAdm, regDatosComPuesto, subirExcelPuestos } from '../../services/Monitor/MonitorService';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

export const useInfoPuesto = () => {
    const toast = useRef();

    const [estaCargando, setEstaCargando] = useState(false);

    const [cargaProyecto, setCargaProyecto] = useState(false);
    const [lstProyecto, setLstProyecto] = useState([]);
    const [proyecto, setProyecto] = useState({});

    const [cargaPuesto, setCargaPuesto] = useState(false);
    const [puesto, setPuesto] = useState({});
    const [lstPuesto, setLstPuesto] = useState([]);

    const [cargaInfoPuesto, setCargaInfoPuesto] = useState(false)
    
    const [procesando, setProcesando] = useState(false)
    const [actualizaPuesto, setActualizaPuesto] = useState(false);

    const [mostrarAnula, setMostrarAnula] = useState(false);

    const [renderKey, setRenderKey] = useState(0)

    useEffect(() => {
        const recuperaProyectos = async () => {
            try {
                setCargaProyecto(true);
                const datos = await obtenerProyectoAdm();
                //console.log('JJ00=', datos);
                setLstProyecto(datos);
            } catch (err) {
                console.error('Error:', err.message);
            } finally {
                setCargaProyecto(false);
            }
        };
        recuperaProyectos()
    }, []);

    useEffect(()=>{
        const recuperaPuestos= async (proyectoId) => {
            try {
                setCargaPuesto(true)
                //const data = await obtenerPuestoAdm(proyectoId)
                const data = await obtenerPuestoActivosAdm(proyectoId)
                //console.log ('JJ11=', data)
                setLstPuesto(data)
            } catch (err) {
                console.error('Error: ', err.message)
            } finally {
                setCargaPuesto(false)
            }
        }
        
        if (proyecto?.id) {
            setFilas([])
            recuperaPuestos(proyecto.id)
        }
    }, [proyecto, actualizaPuesto])

    const denominativos = [];
    const marcasRapidas = [];
    const telefonos = [];

    useEffect(()=>{
        //console.log('JJ00=', puesto)
        const recuperaInfoPuesto = async (puestoId) =>{
            try {
                setCargaInfoPuesto(true)
                const data = await getInfoPuesto(puestoId)
                if (data.infoAdicional && data.infoAdicional.length >=0) {
                    const textoLimpio = data.infoAdicional.trim().replace(/\r\n/g, '\n');
                    const lineas = textoLimpio.split('\n');
                    const regex = /Denominativo:\s*(.*?),\s*Marca Rápida:\s*["']?(.*?)["']?,\s*Teléfono:\s*["']?(.*?)["']?\s*\.?$/;
                    lineas.forEach((linea, index) => {
                        const l = linea.trim(); // Limpiamos espacios de la línea actual
                        if (!l) return; // Saltamos líneas vacías
                        const match = l.match(regex);
                        if (match) {
                            denominativos.push(match[1].replace(/\s+/g, ''));
                            marcasRapidas.push(match[2]);
                            telefonos.push(match[3]);
                        } else {
                            console.warn(`La línea ${index + 1} no coincidió con el formato:`, l);
                        }
                    })
                } else {
                    denominativos.push(data.codigo)
                    marcasRapidas.push(data.codMarcaRapida)
                    telefonos.push(data.telefonos)
                }
                //console.log('00=', denominativos)
                //console.log('11=', marcasRapidas)
                //console.log('22=', telefonos)
                setFilas(inicializaDatos())
            } catch (err) {
                console.error('Error: ', err.message)
            } finally {
                setCargaInfoPuesto(false)
            }
        }
        if (puesto?.puestoId) {
            //recuperaInfoPuesto(puesto.id)
            recuperaInfoPuesto(puesto.puestoId)
        }
    }, [puesto])


    const customUploader = async (evt) => {
        //
        try {
            setEstaCargando(true);
            const prefijo = 'ERROR:';
            const result = await subirExcelPuestos(evt);

            if (result.startsWith(prefijo)) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: result.substring(prefijo.length),
                    life: 5000
                });
            }
            toast.current.show({
                severity: 'success',
                summary: 'Subida Exitosa',
                detail: result,
                life: 3000
            });

            // Opcional: Limpiar los archivos en el componente después de la subida exitosa
            evt.options.clear();
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: error.message,
                life: 5000
            });
        } finally {
            setEstaCargando(false);
        }
    };

    const uploadOptions = {
        disabled: estaCargando
    };

    const cancelOptions = {
        visible: false
    };

    //**********
    const [filas, setFilas] = useState([
        { id: Date.now(), codigo: '', telefono: '', marcaRapida: '' }
    ]);

    const agregarFila = () => {
        const nuevaFila = { 
            id: crypto.randomUUID(), // ID único temporal
            codigo: '', 
            telefono: '', 
            marcaRapida: '' 
        };
        setFilas([...filas, nuevaFila]);
    };
    
    const eliminarFila = (id) => {
        const nuevasFilas = filas.filter(fila => fila.id !== id);
        setFilas(nuevasFilas);
    };

    const manejarCambio = (id, campo, valor) => {
        const nuevasFilas = filas.map(fila => {
            if (fila.id === id) {
                return { ...fila, [campo]: valor };
            }
            return fila;
        });
        setFilas(nuevasFilas);
    };

    const inputTextEditor = (rowData, campo) => {
        return (
            <InputText
                value={rowData[campo]} 
                onChange={(e) => {
                    const newValor = e.target.value.toUpperCase()
                    manejarCambio(rowData.id, campo, newValor)
                }} 
                style={{ width: '100%' }}
            />
        );
    };

    const eliminaBodyTemplate = (rowData) => {
        return (
            <Button label='-' tooltip="Eliminar Fila" className="p-button-danger" onClick={() => eliminarFila(rowData.id)} />
        )
    }

    const inicializaDatos = () => {
        return denominativos.map((val, index) => ({
            id: crypto.randomUUID(),
            codigo: val,
            telefono: telefonos[index],
            marcaRapida: marcasRapidas[index]
        }))
    }

    const validarDatos = () => {
        const todosLlenos = filas.every(fl => 
            fl.codigo.trim() !== '' && 
            fl.telefono.trim() !== '' &&
            fl.marcaRapida.trim() !== ''
        )
        if (filas.length === 0 ) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'No Hay datos para guardar' })
            return false
        }
        if(!todosLlenos) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'Hay filas sin Datos' })
            return false
        }
        return true
    }

    const handleGuardar = async () => {
        //console.log ('YYYY00=', filas)
        if(validarDatos()) {
            const infoProcesa = filas.map(item => {
                return `Denominativo: ${item.codigo.toUpperCase()}, Marca Rápida: ${item.marcaRapida.toUpperCase()}, Teléfono: ${item.telefono.toUpperCase()}.`
            }).join('\n')
            const objPut = {
                puestoId: puesto.puestoId, 
                codigo : filas[0].codigo.toUpperCase(),
                telefonos: filas[0].telefono.toUpperCase(),
                codMarcaRapida: filas[0].marcaRapida.toUpperCase(),
                infoAdicional: infoProcesa
            }
            try {
                setProcesando(true)
                const data = await regDatosComPuesto(objPut)
                toast.current.show({ severity: 'success', summary: 'Exito', detail: 'Se han registrado los cambios' })
                setProyecto({})
                setPuesto({})
                setLstPuesto([])
                setFilas([])
            } catch (err) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'NO se han guardado los cambios' })
                console.error('Error: ', err.message)
            } finally {
                setProcesando(false)
            }
        }
    }

    const abreAnula = () => {
        if (puesto?.puestoId) {
            //console.log ('DD0=', puesto)
            setMostrarAnula(true);
        } else {
            toast.current.show({
                severity: 'warn',
                summary: 'Atencion',
                detail: 'Debe seleccionar un Puesto',
                life: 3000
            });
        }
    };

    const handleAnular = async () => {
        if (!puesto?.puestoId) {
            toast.current.show({ severity: 'warn', summary: 'Atencion', detail: 'Debe seleccionar un Puesto', life: 3000 });
            return;
        }
        try {
            const data = await anulaPuesto(puesto?.puestoId);
            toast.current.show({ severity: 'success', summary: 'Exito', detail: 'Anulacion con Exito', life: 3000 });
            setMostrarAnula(false);
            setPuesto({})
            setActualizaPuesto(prev => !prev)
            setRenderKey(prevKey => prevKey + 1);
        } catch (err) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'No se ha podido anular el Puesto', life: 3000 });
            console.error('Error: ', err.message);
        }
    };

    return {toast, cargaProyecto, proyecto, setProyecto, lstProyecto, cargaPuesto, puesto, setPuesto, lstPuesto, 
        filas, cargaInfoPuesto, inputTextEditor, eliminaBodyTemplate, agregarFila, handleGuardar, procesando, 
        estaCargando, customUploader, cancelOptions, uploadOptions, mostrarAnula, setMostrarAnula, handleAnular, abreAnula,
        renderKey
     }
}